import { SettingsStore, INITIAL_STATE, useSettingsStore } from "./store";

export const actionResetSettings = (): void => {
	useSettingsStore.setState(INITIAL_STATE);
};

export const actionUpdateSettings = (options: SettingsStore): void => {
	useSettingsStore.setState((old) => ({ ...old, ...options }));
};

export const actionToggleSidebar = (sidebarCollapse: boolean): void => {
	useSettingsStore.setState((old) => ({ ...old, sidebarCollapse }));
};
